import { useSelector } from 'react-redux';

export default function useLayer(layerId) {
  const layers = useSelector((state) => state.carto.layers);
  return layers[layerId];
}
